import type { ReactNode } from 'react';
import QuizProgress from './QuizProgress';

interface QuizLayoutProps {
  currentStep: number;
  totalSteps: number;
  children: ReactNode;
  navigation?: ReactNode;
  showProgress?: boolean;
}

export default function QuizLayout({
  currentStep,
  totalSteps,
  children,
  navigation,
  showProgress = true,
}: QuizLayoutProps) {
  return (
    <div className="quiz-layout">
      {showProgress && (
        <div className="quiz-layout__progress">
          <QuizProgress currentStep={currentStep} totalSteps={totalSteps} />
        </div>
      )}

      <main className="quiz-layout__content">
        <div className="quiz-layout__container">{children}</div>
      </main>

      {navigation && (
        <div className="quiz-layout__navigation">
          <div className="quiz-layout__nav-container">{navigation}</div>
        </div>
      )}
    </div>
  );
}
